import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import API from 'utils/api';
import { open } from 'store/modules/modal';
import AgencyCodeNew from '../components/AgencyCodeNew';

const mapDispatchToProps = dispatch => ({
  showError: message => {
    dispatch(
      open({
        modalType: 'error',
        modalProps: { message },
      })
    );
  },
});

const enhance = compose(
  connect(
    null,
    mapDispatchToProps
  ),
  withHandlers({
    onSubmit: props => async (values, { setSubmitting }) => {
      const res = await API.createAgencyCode({
        fullName: values.name,
        email: values.email,
        phone: values.phone,
        code: values.code,
        expireAt: values.isExpirable ? values.expireAt : undefined,
        limit: values.hasLimit ? values.limit : undefined,
      });

      setSubmitting(false);

      if (res) {
        if (res.error) {
          props.showError(res.message);
        } else {
          props.history.push('/dashboard/agency');
        }
      } else {
        props.showError('User could not be created');
      }
    },
  })
);

export default enhance(AgencyCodeNew);
